import React, { useEffect, useState } from "react";
import { api, fmtCurrency, fmtDate } from "@/lib/api";
import { Wallet } from "lucide-react";

const METHODS = {
  cash: "Cash",
  card: "Card",
  upi: "UPI",
  bank_transfer: "Bank Transfer",
  stripe: "Stripe",
};

export default function Payments() {
  const [pays, setPays] = useState([]);

  useEffect(() => {
    api.get("/payments").then(({ data }) => setPays(data));
  }, []);

  const total = pays.reduce((s, p) => s + p.amount, 0);

  return (
    <div className="space-y-6" data-testid="payments-root">
      <div className="flex items-end justify-between border-b border-zinc-200 pb-6">
        <div>
          <div className="label-eyebrow">Ledger</div>
          <h1 className="text-4xl font-bold tracking-tight text-zinc-950">Payment History</h1>
          <p className="text-sm text-zinc-500 mt-2">All cash, card, UPI and bank transfer payments recorded against invoices.</p>
        </div>
        <div className="text-right">
          <div className="label-eyebrow">Lifetime total</div>
          <div className="font-mono text-3xl font-bold text-zinc-950 mt-2" data-testid="payments-total">{fmtCurrency(total)}</div>
        </div>
      </div>

      <div className="brutalist-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-zinc-50 text-zinc-500 uppercase tracking-wider text-[11px] border-b border-zinc-200">
              <th className="text-left px-5 py-3 font-semibold">Date</th>
              <th className="text-left px-5 py-3 font-semibold">Invoice #</th>
              <th className="text-left px-5 py-3 font-semibold">Method</th>
              <th className="text-left px-5 py-3 font-semibold">Recorded by</th>
              <th className="text-left px-5 py-3 font-semibold">Note</th>
              <th className="text-right px-5 py-3 font-semibold">Amount</th>
            </tr>
          </thead>
          <tbody>
            {pays.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-12 text-center text-sm text-zinc-500"><Wallet className="w-6 h-6 mx-auto mb-2 text-zinc-300" />No payments yet.</td></tr>
            )}
            {pays.map((p) => (
              <tr key={p.id} className="border-t border-zinc-200 hover:bg-zinc-50" data-testid={`payment-row-${p.id}`}>
                <td className="px-5 py-3 font-mono text-xs text-zinc-500">{fmtDate(p.at)}</td>
                <td className="px-5 py-3 font-mono text-zinc-950">{p.invoice_number}</td>
                <td className="px-5 py-3">
                  <span className="text-[11px] uppercase tracking-wider px-2 py-1 border border-zinc-300 bg-white">{METHODS[p.method] || p.method}</span>
                </td>
                <td className="px-5 py-3 text-zinc-700">{p.by_name}</td>
                <td className="px-5 py-3 text-zinc-500 text-xs">{p.note || "—"}</td>
                <td className="px-5 py-3 text-right font-mono font-semibold text-emerald-700">{fmtCurrency(p.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
